import { useState } from "react";
import { useStore } from "stook";

import { IVehicle } from "../type";

export default function useVehicleList() {
  const [vehicleList, setVehicleList] = useStore<IVehicle[]>("VehicleList", []);
  const [vehicleListLoaded, setVehicleListLoaded] = useState<boolean>(false);

  return {
    vehicleList,
    vehicleListLoaded,
    setVehicleList,
    setVehicleListLoaded
  };
}
